import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ToastController, LoadingController } from 'ionic-angular';
import { Validators, FormBuilder, FormGroup } from '@angular/forms';
import { B06SupplierPage } from '../b06-supplier/b06-supplier';
import { ServiceApiProvider } from '../../providers/service-api/service-api';

/**
 * Generated class for the B06bSupplierAddPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

interface typeInfo{
  SUPPLIER_TYPE_ID: number;
  TYPE: string;
}

interface statusInfo{
  SUPPLIER_STATUS_ID: number;
  STATUS: string;
}

@IonicPage()
@Component({
  selector: 'page-b06b-supplier-add',
  templateUrl: 'b06b-supplier-add.html',
})
export class B06bSupplierAddPage {
  private todo : FormGroup;
  typeArr: typeInfo[] = [];
  typeItems: typeInfo[] = [];
  statusArr: statusInfo[] = [];
  statusItems: statusInfo[] = [];
  loading: any;
  Status: any;
  public errorMessage: any = "";

  supplierData = {  SUPPLIER_CODE:'',SUPPLIER_NAME:'', ADDR1:'', ADDR2:'', ADDR3:'', 
                    CONTACT_NO:'', EMAIL:'',
                    SUPPLIER_TYPE_ID:'', SUPPLIER_STATUS_ID:'',
  }

  constructor(public navCtrl: NavController, public navParams: NavParams,
              private formBuilder: FormBuilder, public serviceapi: ServiceApiProvider,
              public loadingCtrl: LoadingController) {

    this.todo = this.formBuilder.group({
      supplierCode: ['', Validators.required],
      supplierName: ['', Validators.required],
      address: ['', Validators.required],
      postCode: ['', Validators.required],
      state: ['', Validators.required],
      phone: ['', Validators.required],
      email: ['', Validators.required],
      type: ['', Validators.required],
      status: ['', Validators.required],
    });

    let tbl = ["All"];
    let column = ["All"];
    let value = ["All"];
    
    let tblkey = ["No"];
    let fktbl = ["No"];
    let fkkey = ["No"];
  
    let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

    let mydata = Object.assign(jsonitem);
    let json_data = this.serviceapi.json_readdata(mydata,"1");
    this.showLoader();

    this.serviceapi.readdata(json_data,"SUPPLIER_TYPE","1","1").then((result) => {
      
      this.Status = result["Message"];
      if (this.Status == '1'){
        
        let Records = result["Records"];
        this.typeArr = Records;
        this.typeItems = this.typeArr;

        let tbl = ["All"];
        let column = ["All"];
        let value = ["All"];
        
        let tblkey = ["No"];
        let fktbl = ["No"];
        let fkkey = ["No"];
      
        let jsonitem = this.serviceapi.requestitem(tbl,column,value,tblkey,fktbl,fkkey);

        let mydata = Object.assign(jsonitem);
        let json_data = this.serviceapi.json_readdata(mydata,"1");

        this.serviceapi.readdata(json_data,"SUPPLIER_STATUS","1","1").then((result) => {
          this.loading.dismiss();
          this.Status = result["Message"];
          if (this.Status == '1'){
            
            let Records = result["Records"];
            this.statusArr = Records;
            this.statusItems = this.statusArr;
          }
          else {
            this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
          }
        }, (err) => {
          this.errorMessage = "Loading Error. Please try again.";
          this.loading.dismiss();
        });
      }
      else {
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad B06bSupplierAddPage');
  }

  save(){
    console.log(this.supplierData);
    this.showLoader();
    this.serviceapi.insertdata("SUPPLIER",this.supplierData).then((result) => {
      this.Status = result["Message"];

      if (this.Status == "1"){
        this.loading.dismiss();
        this.navCtrl.setRoot(B06SupplierPage);
      }
      else{
        this.errorMessage = this.serviceapi.displayErrorMessage(this.Status);
        this.loading.dismiss();
      }
    }, (err) => {
      this.errorMessage = "Loading Error. Please try again.";
      this.loading.dismiss();
    });
  }

  cancel(){
    this.navCtrl.pop();
  }
  
  goTo(){
    this.navCtrl.setRoot(B06SupplierPage)
  }

  showLoader(){
    this.loading = this.loadingCtrl.create({
        content: 'Loading...',
        duration: 5000
    });
    this.loading.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/b06b-supplier-add/b06b-supplier-add.ts